module.exports = __webpack_public_path__ + "static/media/img_4.bb861c36.png";